var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 168,
    viewBox: "0 0 145 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1",
    clipPath: "url(#clip0_7882_17683)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M81.3569 123.175C79.7477 128.435 87.5315 133.392 86.2549 141.566C85.7659 144.701 84.364 147.7 82.4563 150.232C80.8955 152.304 78.772 153.89 76.5234 155.179C66.0773 161.165 57.6309 159.758 45.7666 157.685C43.8956 157.358 41.9783 156.969 40.3895 155.925C38.0947 154.417 36.8342 151.787 35.7205 149.274C29.3672 134.925 24.2403 120.029 20.4188 104.808C19.2296 100.073 18.6417 96.3022 20.4553 92.3556",
    fill: "#47254A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M86.118 75.2559C85.9544 74.9722 90.0028 73.6258 90.822 73.2626C97.6491 64.418 108.557 50.614 115.078 41.6097C120.145 34.6146 112.125 30.0239 106.571 34.2499C103.954 36.2411 82.0587 67.2295 80.041 69.827L92.109 50.9993C95.258 46.2814 95.6074 45.3471 98.5496 40.4969C101.655 35.3775 105.332 30.556 101.086 27.3046C98.7467 25.513 94.4427 29.46 92.113 32.0233C89.7507 34.6212 90.2053 34.2877 81.1514 45.1947C75.4324 52.0849 68.3537 61.7897 60.6948 68.363C57.7178 70.9193 53.088 73.782 46.8057 76.9511C40.143 80.312 29.2312 89.2226 29.2414 89.8629",
    fill: "#47254A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M98.1699 81.2708C103.549 74.8909 103.737 74.8546 109.47 67.2737C111.791 64.2035 116.492 59.4973 118.62 55.7958C120.893 51.844 118.755 45.653 110.946 50.647C109.397 51.6374 95.3383 66.7769 92.9645 69.5696L88.8416 74.1331L98.1681 81.2713L98.1699 81.2708Z",
    fill: "#47254A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M90.6195 91.424C91.8983 91.7723 107.617 67.3315 112.393 69.8698C116.953 72.2904 108.875 82.3048 105.655 86.876C105.024 87.77 94.2186 106.261 93.6993 107.223L75.9749 130.602C75.9749 130.602 26.4639 109.285 25.9265 108.856C25.3891 108.427 30.6367 95.3829 30.6367 95.3829L60.6173 78.9305L90.8724 67.4728L97.9962 79.4107L90.6181 91.4263L90.6195 91.424Z",
    fill: "#47254A"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M75.0885 8.61814L30.6187 20.5338C24.8355 22.0834 21.4063 28.0385 22.9595 33.8349L54.605 151.938C56.1582 157.734 62.1055 161.177 67.8887 159.627L112.358 147.711C118.142 146.162 121.571 140.207 120.018 134.41L88.3722 16.3076C86.819 10.5112 80.8717 7.06853 75.0885 8.61814Z",
    fill: "#5B7BE5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M85.0553 26.3403L30.233 41.0299C29.6797 41.1781 29.3515 41.748 29.5002 42.3026L56.1583 141.792C56.307 142.347 56.876 142.676 57.4294 142.528L112.252 127.839C112.805 127.69 113.133 127.12 112.985 126.566L86.3263 27.0761C86.1777 26.5214 85.6086 26.192 85.0553 26.3403Z",
    fill: "#F0EEE4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M88.9191 149.479C85.677 150.348 82.3308 148.411 81.4601 145.161C80.5895 141.912 82.5189 138.561 85.7609 137.693C89.0029 136.824 92.3492 138.761 93.2198 142.01C94.0905 145.26 92.1611 148.61 88.9191 149.479ZM85.9601 138.436C83.127 139.195 81.4429 142.123 82.2032 144.96C82.9635 147.798 85.8877 149.49 88.7189 148.732C91.55 147.973 93.2361 145.045 92.4757 142.208C91.7154 139.37 88.7913 137.677 85.9601 138.436Z",
    fill: "#F0EEE4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M61.3881 27.2503L51.848 29.8065C51.1379 29.9968 50.4045 29.5723 50.2138 28.8605L50.1529 28.6332C49.9622 27.9215 50.385 27.1871 51.0952 26.9969L60.6353 24.4406C61.3454 24.2503 62.0788 24.6748 62.2695 25.3866L62.3304 25.6139C62.5211 26.3256 62.0982 27.06 61.3881 27.2503ZM51.2953 27.744C50.9961 27.8242 50.8161 28.134 50.8969 28.4358L50.9579 28.6631C51.0382 28.9631 51.3477 29.1438 51.6488 29.0631L61.1889 26.5068C61.4882 26.4267 61.6682 26.1168 61.5873 25.815L61.5264 25.5877C61.446 25.2877 61.1366 25.107 60.8355 25.1877L51.2953 27.744Z",
    fill: "#F0EEE4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M55.2145 22.9554C54.2646 23.2099 53.2854 22.6416 53.0308 21.6914C52.7762 20.7411 53.3418 19.7589 54.2899 19.5048C55.238 19.2508 56.219 19.8187 56.4736 20.7689C56.7282 21.7191 56.1625 22.7014 55.2145 22.9554ZM54.4891 20.2482C53.95 20.3927 53.6291 20.9499 53.7739 21.4903C53.9187 22.0306 54.4752 22.3527 55.0143 22.2083C55.5534 22.0638 55.8743 21.5066 55.7295 20.9663C55.5847 20.4259 55.0282 20.1038 54.4891 20.2482Z",
    fill: "#F0EEE4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M46.74 31.1172C45.9314 31.3338 45.0966 30.8506 44.8794 30.0401C44.6622 29.2296 45.1436 28.3937 45.9522 28.1771C46.7608 27.9604 47.5956 28.4436 47.8128 29.2541C48.03 30.0646 47.5486 30.9005 46.74 31.1172ZM46.1519 28.9223C45.7541 29.0289 45.5156 29.4403 45.623 29.8409C45.7303 30.2415 46.1406 30.479 46.5403 30.3719C46.94 30.2648 47.1766 29.8539 47.0692 29.4533C46.9619 29.0528 46.5516 28.8152 46.1519 28.9223Z",
    fill: "#F0EEE4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "skeletton"
  }, /*#__PURE__*/React.createElement("g", {
    id: "jornada ativa"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2169",
    x: 38.1441,
    y: 50.5461,
    width: 21.6,
    height: 3.6,
    rx: 1.8,
    transform: "rotate(-15 38.1441 50.5461)",
    fill: "#D5A2C8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "btn",
    x: 44.7844,
    y: 73.9758,
    width: 40.1,
    height: 5.3,
    rx: 2.65,
    transform: "rotate(-15 44.7844 73.9758)",
    stroke: "#D5A2C8",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 309"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2170",
    x: 41.2499,
    y: 62.1372,
    width: 36,
    height: 1.2,
    rx: 0.6,
    transform: "rotate(-15 41.2499 62.1372)",
    fill: "#D5A2C8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2171",
    x: 42.4923,
    y: 66.7737,
    width: 31.2,
    height: 1.2,
    rx: 0.6,
    transform: "rotate(-15 42.4923 66.7737)",
    fill: "#D5A2C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.3539 51.0305C83.4496 50.9023 83.6207 50.8564 83.7677 50.9196L86.4943 52.0924C86.7912 52.2201 86.8907 52.5917 86.6975 52.8507L84.9225 55.2296C84.8269 55.3579 84.6558 55.4037 84.5088 55.3405C84.3035 55.2522 84.2347 54.9953 84.3683 54.8162L85.6192 53.1396C85.8124 52.8806 85.7129 52.509 85.416 52.3813L83.4944 51.5548C83.2892 51.4665 83.2203 51.2096 83.3539 51.0305Z",
    fill: "#D5A2C8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "historico"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2169_2",
    x: 49.0145,
    y: 91.115,
    width: 21.6,
    height: 3.6,
    rx: 1.8,
    transform: "rotate(-15 49.0145 91.115)",
    fill: "#D5A2C8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 307"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2170_2",
    x: 52.4309,
    y: 103.865,
    width: 36,
    height: 1.2,
    rx: 0.6,
    transform: "rotate(-15 52.4309 103.865)",
    fill: "#D5A2C8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2171_2",
    x: 53.6732,
    y: 108.502,
    width: 31.2,
    height: 1.2,
    rx: 0.6,
    transform: "rotate(-15 53.6732 108.502)",
    fill: "#D5A2C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2 (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.5349 92.7585C94.6306 92.6303 94.8017 92.5844 94.9486 92.6476L97.6753 93.8204C97.9721 93.9481 98.0717 94.3197 97.8784 94.5787L96.1035 96.9577C96.0078 97.0859 95.8367 97.1317 95.6898 97.0685C95.4845 96.9802 95.4157 96.7233 95.5493 96.5442L96.8002 94.8676C96.9934 94.6086 96.8939 94.237 96.597 94.1093L94.6754 93.2828C94.4701 93.1945 94.4013 92.9376 94.5349 92.7585Z",
    fill: "#D5A2C8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 310"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2170_3",
    x: 56.1579,
    y: 117.775,
    width: 36,
    height: 1.2,
    rx: 0.6,
    transform: "rotate(-15 56.1579 117.775)",
    fill: "#D5A2C8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2171_3",
    x: 57.4002,
    y: 122.411,
    width: 31.2,
    height: 1.2,
    rx: 0.6,
    transform: "rotate(-15 57.4002 122.411)",
    fill: "#D5A2C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2 (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.2619 106.668C98.3576 106.54 98.5287 106.494 98.6756 106.557L101.402 107.73C101.699 107.858 101.799 108.229 101.605 108.488L99.8305 110.867C99.7348 110.995 99.5637 111.041 99.4168 110.978C99.2115 110.89 99.1427 110.633 99.2763 110.454L100.527 108.777C100.72 108.518 100.621 108.146 100.324 108.019L98.4024 107.192C98.1971 107.104 98.1283 106.847 98.2619 106.668Z",
    fill: "#D5A2C8"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M20.4547 92.3534C24.6235 81.9086 29.7877 71.8621 35.8556 62.4002C36.5088 61.3805 37.2558 60.3017 38.4004 59.9111C40.3387 59.248 42.3263 60.8881 43.3613 62.6616C46.1575 67.4459 45.3553 73.6796 42.7116 78.5437C41.4986 80.7758 39.9202 82.8342 39.1048 85.2413C37.0791 91.2218 40.1582 97.8354 39.0906 104.06",
    fill: "#47254A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7882_17683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110.641,
    height: 144,
    fill: "white",
    transform: "translate(0 28.738) rotate(-15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.e2df0df50c031c2ed2049454dc284e9a.svg";
export { ForwardRef as ReactComponent };